import React, { FC } from "react";

import FlexibleDateBestPriceInner from "./FlexibleDateBestPriceInner";
import { useGetFlexDatesData } from "./useGetFlexDatesData";
import Frame from "../Frame";
import flights_web_aa_flexibility_prediction from "../../../utils/experiments/funnel/flights_web_aa_flexibility_prediction";

const FlexibleDateBestPriceDesktop: FC = () => {
  const data = useGetFlexDatesData();
  if (!data) {
    return null;
  }

  const { dates, currentBestPrice, cheaperCount, isOneWay } = data;

  return (
    <Frame mb={4}>
      <FlexibleDateBestPriceInner
        carouselSize="medium"
        dates={dates}
        currentBestPrice={currentBestPrice}
        cheaperCount={cheaperCount}
        isOneWay={isOneWay}
        onItemClick={flights_web_aa_flexibility_prediction.goals.click_on_flexi_banner}
      />
    </Frame>
  );
};

export default FlexibleDateBestPriceDesktop;
